<fieldset [ngClass]="classeModeApplication">
	<legend>{{ 'SIGALE_ANGULAR.COMPONENTS.PROPRIETE.TITRE' | translate }}</legend>
	<hr *ngIf="!modeApplicationCohabitation">
	<div id="proprietes" class="col-8 w-75 mx-auto">
		<p-table id="dg-proprietes" [loading]="loadingIndicator" [value]="appProperties" loadingIcon="app-spinner">
			<ng-template pTemplate="header">
				<tr>
					<th class="text-center col-proprietes" pSortableColumn="property">
						{{ 'SIGALE_ANGULAR.COMPONENTS.PROPRIETE.DG.PROPRIETE' | translate }}
						<p-sortIcon field="property"></p-sortIcon>
					</th>
					<th  class="text-center col-valeurs" pSortableColumn="value">
						{{ 'SIGALE_ANGULAR.COMPONENTS.PROPRIETE.DG.VALEUR' | translate }}
						<p-sortIcon field="value"></p-sortIcon>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-rowData>
				<tr>
					<td class="col-proprietes"> {{ rowData.property }}</td>
					<td class="col-valeurs"> {{ rowData.value }}</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</fieldset>
